export default __webpack_public_path__ + "static/media/Background.b25a4267.jpg";